import * as jsxRuntime from "C:\\Users\\Akhil\\Downloads\\76-eido-3.0-soendrekyst\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment